var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3550_22644)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8616 15.4686L27.147 7H25.4206L19.0947 14.3532L14.0423 7H8.21484L15.8551 18.1193L8.21484 27H9.94134L16.6216 19.2348L21.9574 27H27.7848L19.8612 15.4686H19.8616ZM17.497 18.2173L16.7228 17.1101L10.5634 8.29967H13.2152L18.1859 15.4099L18.9601 16.5172L25.4214 25.7594H22.7696L17.497 18.2177V18.2173Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3550_22644"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(8 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.c6b4d2d88c48578602b5977ffeb0ef62.svg";
export { ForwardRef as ReactComponent };